var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-widget',{staticClass:"mb-4",attrs:{"title":_vm.$t('Password Settings')}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('CustomerNewPasswordForm',{attrs:{"customer":_vm.customer}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }